import { globalStyle, style } from '@vanilla-extract/css';

/** Mirrors client TipTap `externalSelectableNodeStyles` for editor-only post header fields. */
export const selectable = style({
  position: 'relative',
  pointerEvents: 'auto',
  width: '100%',
  padding: '2px',
});

globalStyle(`${selectable}::after`, {
  content: '""',
  position: 'absolute',
  inset: 0,
  border: '1px solid transparent',
  pointerEvents: 'none',
  backgroundOrigin: 'border-box',
  backgroundImage: `
    linear-gradient(to right, var(--node-border-color, transparent) 50%, transparent 50%),
    linear-gradient(to right, var(--node-border-color, transparent) 50%, transparent 50%),
    linear-gradient(to bottom, var(--node-border-color, transparent) 50%, transparent 50%),
    linear-gradient(to bottom, var(--node-border-color, transparent) 50%, transparent 50%)
  `,
  backgroundPosition: '0 0, 0 100%, 0 0, 100% 0',
  backgroundRepeat: 'repeat-x, repeat-x, repeat-y, repeat-y',
  backgroundSize: '12px 1px, 12px 1px, 1px 12px, 1px 12px',
});

globalStyle(`${selectable}:hover::after`, {
  vars: {
    '--node-border-color': '#7c3aed',
  },
});

export const selected = style({});

globalStyle(`${selected}::after`, {
  backgroundImage: 'none',
  borderColor: '#7c3aed',
});
